import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SelectedAnzeige {
  a_vorname: string;
  a_name: string;
  a_geboren: string;
  a_verstorben: string;
  tmst_verstorben: number;
  a_text: string;
  a_ruhestätte: string;
  a_trauerkarte: string;
  a_trauerkartePfad: string;
  a_update: number;
  a_public : boolean;
  a_order: number;
  a_produkteAuswahl : boolean;
  a_anzeigen_ab: string;
  a_anzeigendauer: string;
  a_anz: string = "7";

  constructor() {
  }


  setSelected( a_vorname: string, a_name: string, a_trauerkartePfad:string, a_trauerkarte:string) {
    this.a_vorname = a_vorname;
    this.a_name = a_name;
    this.a_trauerkarte = a_trauerkarte;
    this.a_trauerkartePfad = a_trauerkartePfad;
  }


}
